import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuService } from '../../services/menu.service';
import { CommonModule } from '@angular/common';
import { NgZone } from '@angular/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-menu',
  imports: [RouterModule, CommonModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})
export class MenuComponent {

  constructor(public menuService: MenuService, private ngZone: NgZone) {

  }

  /*   scrollTo(targetId: string): void {
      const el = document.getElementById(targetId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        el.focus(); // opzionale se vuoi spostare anche il focus
      }
    } */

  /*   scrollTo(id: string): void {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        el.focus();
      }
    }, 100); // Ritardo minimo
  } */
  /* scrollTo(id: string): void {
    this.ngZone.onStable
      .pipe(take(1)) // esegue solo al primo evento "stable"
      .subscribe(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          el.focus();
        }
      });
  } */
  /*   scrollTo(id: string): void {
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const yOffset = -120; // altezza del tuo header (es. 100-120px)
          const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
          el.focus(); // opzionale per accessibilità
        }
      }, 100);
    } */
/*   scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      const headerOffset = 109; // ← adattalo all'altezza reale del tuo header sticky
      const elementPosition = el.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      el.focus(); // opzionale, per accessibilità
    }
  } */
}
